import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const About = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              What We Do As
            </h2>
            <p className="text-3xl text-gray-900 font-semibold">
              Property Consultants In Your City.
            </p>
          </div>

          {/* Grid Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* Image 1 */}
            <div className="group relative overflow-hidden rounded-lg shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
                alt="Bhagat Prop Built | Property Consultant"
                className="w-full h-[400px] object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6">
                <div className="text-white">
                  <h3 className="text-xl font-bold mb-2">Bhagat Prop Built | Property Consultant</h3>
                  <p className="text-sm">Your trusted real estate partner for residential and commercial properties.</p>
                </div>
              </div>
            </div>

            {/* Image 2 */}
            <div className="group relative overflow-hidden rounded-lg shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1560518883-ce09059eeffa"
                alt="Bhagat Prop Built | Real Estate Experts"
                className="w-full h-[400px] object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6">
                <div className="text-white">
                  <h3 className="text-xl font-bold mb-2">Bhagat Prop Built | Real Estate Experts</h3>
                  <p className="text-sm">Your trusted real estate partner for residential and commercial properties.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Description */}
          <div className="max-w-5xl mx-auto text-center mb-8">
            <p className="text-lg text-gray-700 leading-relaxed">
              Welcome to <strong>Bhagat Prop Built</strong>, your reliable property consultants! We handle a wide variety of residential and commercial properties. Our professional team is dedicated to providing top-notch service and getting the right property for you. With extensive market experience and personalized assistance, we will walk you through every aspect of your real estate experience comfortably. Customer satisfaction is cherished at Bhagat Prop Built, and we promise a smooth and successful selling, buying, or investment experience.
            </p>
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <Link to="/about">
              <Button 
                size="lg" 
                className="bg-[#B8944A] hover:bg-[#A07D3A] text-white px-10 py-6 text-lg font-semibold rounded-full transition-all duration-300"
              >
                Explore More
                <ArrowRight className="ml-2" size={22} />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;